module.exports = __webpack_public_path__ + "static/WEDDING E&M-355-b791f7bcd3ad59a2961f516b90aa2c76.jpg";